var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',{ref:"fileRefs",staticClass:"upload-demo",attrs:{"action":"none","accept":".xls,.xlsx","show-file-list":false,"http-request":_vm.fileRequestBackId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }